module.exports = __webpack_public_path__ + "media/images/Gestion de l’eau-ffcdaa4959bf6a009ba67d70eb1a3d8a.svg";